import React, { Component } from 'react'
import { Fieldset } from 'react-gridforms'
import acc from 'accounting'

class Billing extends Component {

  render() {
    const advising = this.props.advising
    const meta = this.props.billing.get('meta')
    const misc = this.props.billing.get('misc')
    const reg = this.props.billing.get('reg')
    const cor_url = this.props.corUrl

    return (
      <div className="cor-billing">
        <form className="grid-form">
          <Fieldset legend="Billing Assessment">
            <div className="grid-container">
              <div className="misc-grid">
                <form className="grid-form">
                  <Fieldset legend="Miscellaneous Breakdown">
                    <table className="table table-condensed">
                      <thead>
                        <tr>
                          <th>Code</th>
                          <th>Name</th>
                          <th className="text-right">Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {misc.map((m, k) => {
                          return (
                            <tr key={k}>
                              <td><small>{m.get('fee_code')}</small></td>
                              <td><small>{m.get('fee_name')}</small></td>
                              <td className="text-right"><small>{acc.formatNumber(m.get('amount'), 2)}</small></td>
                            </tr>
                          )
                        })}
                        <tr>
                          <th className="text-right" colSpan="2">Total Miscellaneous:</th>
                          <th className="text-right">{acc.formatNumber(meta.get('total_misc'), 2)}</th>
                        </tr>
                      </tbody>
                    </table>
                  </Fieldset>
                </form>
              </div>
              <div className="asses-grid">
                <form className="grid-form">
                  <Fieldset legend="Assessment of Fees">
                    <table className="table table-condensed">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th className="text-right">Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {reg.map((r, k) => {
                          return (
                            <tr key={k}>
                              <td><small>{r.get('fee_name')}</small></td>
                              <td className="text-right"><small>{acc.formatNumber(r.get('amount'), 2)}</small></td>
                            </tr>
                          )
                        })}
                        <tr>
                          <td>Miscellaneous Fees:</td>
                          <td className="text-right">{acc.formatNumber(meta.get('total_misc'), 2)}</td>
                        </tr>
                        <tr>
                          <th className="text-right">Total Billing:</th>
                          <th className="text-right">{acc.formatNumber(meta.get('total_amount'), 2)}</th>
                        </tr>
                      </tbody>
                    </table>
                  </Fieldset>
                </form>
              </div>
              <div className="sign-grid">
                <div className="sign">
                  <em><small>Certified by: </small></em>
                  <strong>ADELYN C. IBARRA</strong><br />
                  <em><small>Designation: </small></em>Registrar<br />
                  <em><small>Date Printed: </small></em>
                  <small>{advising.get('printed_date')}</small>
                </div>
                <div className="disclaimer">
                  Disclaimer: Actual signature may not be needed since this is a computer-generated document. Online copy of this document is found here:{' '}
                  <em className="cor-url">{cor_url}</em>
                </div>
              </div>
            </div>
          </Fieldset>
        </form>
      </div>
    )
  }
}

export default Billing


// WEBPACK FOOTER //
// ./src/containers/COR2/billing.js